import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HomeComponent } from './home.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AuthenticationService } from './services/authentication.service';
import { AdminAuthenticationService } from './services/admin-authentication.service';

import { OtpComponent } from './users/otp/otp.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ShowDialogComponent } from './components/show-dialog/show-dialog.component';

import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgxMaskModule,IConfig } from 'ngx-mask';
import { AddReagentDialogComponent } from './components/add-reagent-dialog/add-reagent-dialog.component'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
	HomeComponent,
	OtpComponent,
	ConfirmDialogComponent,
	ShowDialogComponent,
	AddReagentDialogComponent
  ],
  imports: [
    BrowserModule,
	BrowserAnimationsModule,
	AppRoutingModule,
	HttpClientModule,
	NgxMaskModule.forRoot(options),
	TranslateModule.forRoot({
		loader: {
			provide: TranslateLoader,
			useFactory: createTranslateLoader,
			deps: [HttpClient]
		}
	}),
	FormsModule,
	ReactiveFormsModule,
	Ng4LoadingSpinnerModule.forRoot()
  ],
	providers: [AuthenticationService,AdminAuthenticationService],
    bootstrap: [AppComponent],
	entryComponents: [
		OtpComponent,
		ConfirmDialogComponent,
		ShowDialogComponent,
		AddReagentDialogComponent
	]
})
export class AppModule { }
